import {
  LedgerReportButtonWidgetProps,
  useLedgerReportHeader,
} from "./use-button-widget";
import { useStyle } from "./style";
import { Button } from "@mui/material";
import { ReportActionsMenu } from "@/pages-components/transaction-journal-report/widgets/button-widget/report-actions-menu/report-actions-menu";
import { useTheme } from "@/contexts/theme/useTheme";

const LedgerReportButtonWidget = ({
  onClickCreateNewTransaction,
  onClickPrintCard,
  onClickShowCard,
  onClickSendingTicketByEmail,
  onClickAdjustments,
}: LedgerReportButtonWidgetProps) => {
  const { classes } = useStyle();
  const { currentTheme } = useTheme();
  const { primaryActions, menuActions } = useLedgerReportHeader({
    onClickCreateNewTransaction,
    onClickPrintCard,
    onClickShowCard,
    onClickSendingTicketByEmail,
    onClickAdjustments,
  });

  const isHpClient = currentTheme === "hp-client";
  const getVariant = (index: number) => {
    if (isHpClient) {
      if (index === 2) return "contained";
      return "text"; // index 0 and 1
    }
    return index === 0 ? "contained" : "outlined";
  };
  const getButtonSx = (index: number) =>
    (isHpClient ? index === 2 : index === 0)
      ? classes.primaryButton
      : classes.optionsButtons;

  return (
    <div style={classes.mainContainer}>
      {primaryActions.map((action, index) => (
        <Button
          key={index}
          variant={getVariant(index)}
          onClick={action.onclick}
          sx={getButtonSx(index)}
        >
          {action.name}
        </Button>
      ))}

      {menuActions.length > 0 && (
        <ReportActionsMenu
          actions={menuActions.map((action) => ({
            name: action.name,
            icon: action.icon,
            onClick: action.onclick,
          }))}
        />
      )}
    </div>
  );
};
export { LedgerReportButtonWidget };
